import React from "react";
import {
  AboutContent,
  AboutDetailsContainer,
 
  AboutImageContainer,
  Resume,
  ResumeLink,
  StyledAbout,
} from "../styles/About.styled";
import { SectionHeading, SectionTitle } from "../styles/SectionHeading";
import { StyledParagraph } from "../styles/Typography.styled";
import myImage from "../../assets/projects/myimage.png";
import downloadIcon from "../../assets/icons/download-icon.svg";
// import resume from "../../assets/resume.pdf";

const About = () => {
  return (
    <StyledAbout id="about">
      <SectionHeading dark="true" mb="3rem">
        <SectionTitle dark="true" number="02">
          About Me
        </SectionTitle>
      </SectionHeading>
      <AboutContent>
        <AboutImageContainer>
          {/* <AboutImage src={myImage} /> */}
          <img src={myImage} alt="" style={{height:"80%",marginLeft:"13%"}}/>
        </AboutImageContainer>
        <AboutDetailsContainer>
          <StyledParagraph>
            My name is Vikas Yadav ,i am from Ayodhya Uttar Pradesh , currently learning React and React -Native .
          </StyledParagraph>
          <StyledParagraph>
            I love to design and create responsive websites or web and mobile apps from
            scratch. The technologies, tools and languages I am using to build
            my projects are HTML, CSS, JavaScript, REACT JS, TailwindCSS,
            Bootstrap, React-Native, Git and GitHub, and VS Code.
          </StyledParagraph>
          <StyledParagraph>
            I have eagerness to learn something new every day and I love to
            share my knowledge and discuss about exciting things.
          </StyledParagraph>
          <Resume>
            <ResumeLink
              href={""}
              icon={downloadIcon}
              download="vikas-yadav"
            >
              <a href="https://drive.google.com/file/d/1jjeL-6I6m9S852Xbt-48fps2LY_YFAuR/view?usp=share_link"  target="_blank"
            rel="noopener noreferrer" >Download Resume</a>
             
            </ResumeLink>
          </Resume>
        </AboutDetailsContainer>
      </AboutContent>
    </StyledAbout>
  );
};

export default About;
